import axios from "../utils/axios";

// get all priviledge
export const getAllPriviledge = () => {
  return axios.get("api/privilege");
};
